/**
 * Run a callback once the DOM is parsed, without depending on the
 * DOMContentLoaded event firing.
 *
 * The Usercentrics autoblocker (loaded first in the head on production only,
 * see _layouts/site.twig) monkey-patches EventTarget.prototype.addEventListener
 * and queues DOMContentLoaded/load registrations so it can replay them for
 * scripts it has blocked. Our first-party bundle is not blocked, but the patch
 * is global, so handlers registered with `document.addEventListener` are
 * swallowed and never run. Poll readyState instead of trusting the event.
 *
 * @param  {Function} fn The callback to run once the DOM is ready
 */
export default function domReady (fn) {
  let ran = false

  const run = function () {
    if (ran) return
    ran = true
    fn()
  }

  if (document.readyState !== 'loading') {
    run()
    return
  }

  document.addEventListener('DOMContentLoaded', run)

  const poll = setInterval(function () {
    if (document.readyState !== 'loading') {
      clearInterval(poll)
      run()
    }
  }, 50)
}
